<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Atribuição de cota de exame"
    >
        <Form
            :data="data"
            :item="item"
            :indexExame="indexExame"
            @save="handleExit"
            ref="Form"
        />

         <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import Form from './Form'

// Mixins.
import { repository, object, data, mask, formats } from '@/mixins'

// Moment.
import moment from 'moment'

export default {
    components: { Form },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }
    },
    data: () => ({
        indexExame: null,
        item: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(index, item) {

            this.indexExame = index
            this.item = item

            if (item.exameAlterado) {
                this.$refs.Modal.show()
            } else {

                this.getCotaLaboratorioExame(item)
            }
        },
        handleExit(data) {

            this.$emit('save', data)
        },
        handleSave() {

            this.$refs.Form.save()
        },
        getCotaLaboratorioExame(item) {

            this.setLoading()

            this.repositories.parametrizacao.getCotaLaboratorioExame({
                infraestrutura_id: item.infraestruturaId,
                cota_tipo_id: item.cotaTipoId,
                cota_id: item.id,
                inicio: moment(item.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                fim: moment(item.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            })
                .then(response => {

                    this.item.exames = response.data

                    item.exames = response.data
                    item.exameAlterado = true

                    this.$refs.Modal.show()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ repository, object, data, mask, formats ],
    props: {
        data: { type: Object, required: true },
    }
}
</script>